import { NavbarComponent } from './navbar.component';
import { FooterComponent } from './footer.component';
import { NavbarItem, ICONS } from './NavbarItem';
import { TermsOfUseComponent } from './terms-of-use.component';
import { HelpIconComponent } from './help-icon.component';
import { ContactUsModalComponent } from './contact-us-modal.component';
import { LearnMoreModalComponent } from './learn-more-modal.component';

const LAYOUT = [NavbarComponent, FooterComponent, TermsOfUseComponent, HelpIconComponent, ContactUsModalComponent, LearnMoreModalComponent];

export {
  NavbarComponent,
  FooterComponent,
  TermsOfUseComponent,
  HelpIconComponent,
  ContactUsModalComponent,
  LearnMoreModalComponent,
  NavbarItem,
  ICONS,
  LAYOUT
};



// WEBPACK FOOTER //
// ./src/app/shared/components/layout/index.ts